var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1664 11.9063L13.7837 20.6384C13.612 20.8171 13.3871 20.9065 13.1622 20.9065C12.9373 20.9065 12.7123 20.8171 12.5407 20.6384L7.83363 15.7352C7.49039 15.3777 7.49039 14.7981 7.83363 14.4405C8.17682 14.0829 8.73334 14.0829 9.07658 14.4405L13.1622 18.6963L20.9234 10.6116C21.2666 10.254 21.8231 10.254 22.1664 10.6116C22.5096 10.9691 22.5096 11.5488 22.1664 11.9063ZM25.6066 4.57642C22.7735 1.62531 19.0066 0 15 0C10.9933 0 7.22648 1.62531 4.39336 4.57642C1.56029 7.52759 0 11.4514 0 15.625C0 19.7986 1.56029 23.7224 4.39336 26.6735C7.22648 29.6247 10.9934 31.25 15 31.25C19.0066 31.25 22.7735 29.6247 25.6066 26.6736C28.4397 23.7224 30 19.7986 30 15.625C30 11.4514 28.4397 7.52765 25.6066 4.57642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.1a792ffaa7714223daa0c7033cbe960d.svg";
export { ForwardRef as ReactComponent };